export { default } from '@esentai/core/features/mallStats/api';
